export default __webpack_public_path__ + "static/media/silence.08708c3d.svg";